module.exports = {
	"articleTitle1": "Students and professionals team up for first Ann Arbor Health ...",
	"catImage": "bluestar.png",
	"totalCats": 1,
	"name": "Palmer Commons",
	"articleLink1": "https://www.michigandaily.com/section/news/ann-arbor-hosts-health-hackathon",
	"articleLink2": "https://www.michigandaily.com/content/campus-voting-map",
	"articleSnippet1": "Jun 26, 2016 ... Engineering junior AJ Goldstein presents his app Balance at A2 Health Hacks at \nPalmer Commons on Wednesday. Sinduja Kilaru/Daily.",
	"articleSnippet2": "Nov 2, 2010 ... Ward 2, Precinct 2 voters should go to Palmer Commons, not Markley Hall. \nVoters in Precincts 1 and 2 in Ward 3 should head to the Michigan ...",
	"totalMisc": 1,
	"articleTitle2": "Jump to navigation",
	"address": "100 Washtenaw Ave, Ann Arbor, MI 48109",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170404/jrl.NEW_.Muslim-Monologues.4.4.17.0004.jpg?itok=pOnWfVBk",
			"author": "Julia Lawson/Daily",
			"caption": "LSA Freshman Ayah Kutmah speaks about her experience wearing a hijab at the Muslim Monologues in Palmer commons on Tuesday night."
		}
	],
	"position": {
		"lat": 42.28071,
		"lng": -83.733875
	},
	"tips": [
		{
			"text": "The 2nd-5th floors have amazing study spots/nooks — there are booths and tables, and it is normally silent and empty.",
			"person": "Amelia Cacchione"
		},
		{
			"text": "The whole building is just meeting rooms, so there is also normally a chance you can find an empty room to use.",
			"person": "Amelia Cacchione"
		},
		{
			"text": "On the 1st floor there's a cafe for sustenance!",
			"person": "Amelia Cacchione"
		}
	],
	"bathroomrating": [
		{
			"rating": 5,
			"bathroom": "All Floors"
		}
	],
	"categories": {
		"academics": 1,
		"universitybuilding": 1,
		"location": 1,
		"studyspot": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/palmercommons.json
// module id = 942
// module chunks = 0